import { api } from "..";
import { BlockUserPayload, SimpleSuccessResponse } from "./types";

export const blockUser = async (
  payload: BlockUserPayload
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.post("/chats/block", payload);
  return res.data;
};

export const unblockUser = async (
  userId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.delete(`/chats/block/${userId}`);
  return res.data;
};
